const r = {
  "story-staging-hero": "story-staging-hero",
  "story-staging-hero__background": "story-staging-hero__background",
  "story-staging-hero__wrapper": "story-staging-hero__wrapper",
  "story-staging-hero__content": "story-staging-hero__content",
  "story-staging-hero__header": "story-staging-hero__header",
  "story-staging-hero__headline": "story-staging-hero__headline",
  "story-staging-hero__text": "story-staging-hero__text",
  "story-staging-hero__divider": "story-staging-hero__divider",
  "story-staging-hero__story-type-wrapper": "story-staging-hero__story-type-wrapper",
  "story-staging-hero__story-type": "story-staging-hero__story-type",
  "story-staging-hero__tag-wrapper": "story-staging-hero__tag-wrapper",
  "hero--variant-a": "hero--variant-a",
  "story-staging-hero__letter": "story-staging-hero__letter",
  "story-staging-hero__image": "story-staging-hero__image",
  "hero--variant-b": "hero--variant-b",
  "story-staging-hero__icon": "story-staging-hero__icon"
};
export {
  r as default
};
